<div class="radio-btn">
  <label>{{ label }}</label>
  <mat-radio-group [formControl]="radioControl">
    <mat-radio-button *ngFor="let option of options" [value]="option.value">
      {{ option.label }}
    </mat-radio-button>
  </mat-radio-group>
</div>
